import { ContentCell } from './styled';

interface Props {
    value?: string;
    fallbackValue?: string;
}

const OriginalContentColumn = ({ value, fallbackValue = '' }: Props) => {
    const cellValue = value || fallbackValue;
    return <ContentCell>{cellValue}</ContentCell>;
};

export default OriginalContentColumn;
